import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Auth0ClientService } from '@app/core/auth0-client.service';

import { environment } from '../../environments/environment';
import { GetRegistrationContextGraphQLService } from './get-registration-context-graphql.service';

declare const grecaptcha: any;

@Component({
  selector: 'om-auth-redirect',
  template: '',
})
export class AuthRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth0ClientService: Auth0ClientService,
    private getRegistrationContextGraphQL: GetRegistrationContextGraphQLService,
  ) {}

  ngOnInit(): void {
    const hctx = this.route.snapshot.queryParamMap.get('hctx');
    const returnUrl = this.route.snapshot.queryParamMap.get('return_url');

    if (!hctx) {
      this.redirectToLogin();
      return;
    }

    this.performTokenHandoff(hctx, returnUrl);
  }

  private performTokenHandoff(contextId: string, returnUrl: string | null): void {
    this.getRecaptchaToken()
      .then((reCaptchaToken: string) => {
        this.getRegistrationContextGraphQL
          .mutate({
            input: {
              contextId,
              reCaptchaToken,
            },
          })
          .subscribe({
            next: result => {
              const token = result.data?.getRegistrationContext?.token;
              if (!token) {
                this.redirectToLogin();
                return;
              }

              this.auth0ClientService.persistToken(token);
              window.location.href = this.validateReturnUrl(returnUrl) ? returnUrl : '/';
            },
            error: () => {
              this.redirectToLogin();
            },
          });
      })
      .catch(() => {
        this.redirectToLogin();
      });
  }

  private getRecaptchaToken(): Promise<string> {
    if (!environment.devRoutes && typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
      return grecaptcha.enterprise.execute(environment.newRecaptchaSiteKey, {
        action: 'getRegistrationContext',
      });
    }
    return Promise.resolve('disabled');
  }

  private validateReturnUrl(url: string | null): boolean {
    if (!url) {
      return false;
    }
    if (!url.startsWith('/')) {
      return false;
    }
    if (url.startsWith('//')) {
      return false;
    }
    if (url.includes('://')) {
      return false;
    }
    return true;
  }

  private redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}
